document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('svg').forEach(svg => {
    const svgRect = svg.getBoundingClientRect();
    const centerX = svgRect.x + svgRect.width / 2;
    const centerY = svgRect.y + svgRect.height / 2;

    svg.querySelectorAll('#AnimateFromCenter > *').forEach(el => {
      const rect = el.firstChild.getBoundingClientRect();
      const deltaX = centerX - (rect.x + rect.width / 2);
      const deltaY = centerY - (rect.y + rect.height / 2);

      el.style.setProperty('transform', `translate(${Math.round(deltaX / 5)}px, ${Math.round(deltaY / 5)}px)`);
    });
  });
});
